import React from 'react';
import { useSelector } from 'react-redux';
import { Layout, Modal } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { removeCookie } from 'utils/cookie';
import LanguageSwitcher from 'components/LanguageSwitcher';
import { Dropdown, Menu, Row, Button } from 'antd';
// images
import IconHeader from 'assets/images/Icon header.png';
import BackBtn from 'assets/images/backBtn.svg';
import IconDropdown from 'assets/images/iconDropdown.svg';

import { sidebarItemData } from './AppSidebar';

const { Header } = Layout;

const AppHeader = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const authUser = useSelector((state) => state.auth.authUser);

    const handleLogout = () => {
        removeCookie(process.env.REACT_APP_TOKEN_NAME);
        window.location.href = '/signin';
    };

    const handleProfile = () => {
        navigate('/profile');
    };

    const handleBack = () => {
        const isFormChanged = Number(sessionStorage.getItem('is_form_changed'));

        if (isFormChanged) {
            sessionStorage.setItem('is_form_changed', 0);

            Modal.confirm({
                title: t('alert_go_back'),
                okText: t('ok'),
                cancelText: t('cancel'),
                onOk: () => goBack(),
                onCancel: () => sessionStorage.setItem('is_form_changed', 1),
            });
        } else {
            goBack();
        }
    };

    const goBack = () => {
        navigate(-1);
    };

    const backButton = !sidebarItemData.map((e) => e.path).includes(location.pathname);

    const menu = (
        <Menu
            items={[
                {
                    key: 'profile',
                    label: (
                        <Button className="btn-profile" type="link" onClick={handleProfile}>
                            {t('profile')}
                        </Button>
                    ),
                },
                {
                    key: 'logout',
                    label: (
                        <Button className="btn-logout" type="link" onClick={handleLogout}>
                            {t('logout')}
                        </Button>
                    ),
                },
            ]}
        />
    );

    return (
        <Header className="app-header">
            {backButton ? (
                <Button className="btn-back" onClick={handleBack}>
                    <img src={BackBtn} alt="" /> {t('back')}
                </Button>
            ) : (
                <div></div>
            )}
            <div className="header-menu">
                <Dropdown overlay={menu} className="header-profile-menu">
                    <a onClick={(e) => e.preventDefault()}>
                        <Row justify="space-between">
                            <div>
                                <img
                                    src={authUser.avatarUrl ? authUser.avatarUrl : IconHeader}
                                    className="mr-8 image-avatar"
                                    alt=""
                                />
                                {authUser.name}
                            </div>
                            <img src={IconDropdown} alt="" />
                        </Row>
                    </a>
                </Dropdown>
                <LanguageSwitcher />
            </div>
        </Header>
    );
};

export default AppHeader;
